import { render } from "./ConfirmRegistrationView.vue?vue&type=template&id=6127dd9f&scoped=true&ts=true&lang=pug"
import script from "./ConfirmRegistrationView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmRegistrationView.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmRegistrationView.vue?vue&type=style&index=0&id=6127dd9f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6127dd9f"]])

export default __exports__